import * as React from 'react';

import { useAuth0 } from '@auth0/auth0-react';
import { Box } from '@mui/material';

import { VERIFICATION_STATUS } from '@itp/prisma-talent/generated/client';
import { useCreateTalentProfile, useUser } from '@itp/talent';
import { Link } from '@itp/talent/components/core/link';
import { getRoutingPath, ROUTES } from '@itp/talent/constants/routingPath';
import { useLocalAuth } from '@itp/talent/context/localAuthContext';
import { theme } from '@itp/talent/theme';

import { NotificationsMenu } from '../../notifications';

export const TopNavigation = () => {
  const { isAuthenticated: isAuth0Authenticated } = useAuth0();
  const { isAuthenticated: isLocalAuthenticated } = useLocalAuth();
  const isAuthenticated = isAuth0Authenticated || isLocalAuthenticated;
  const { user } = useUser();
  const { createTalentProfile } = useCreateTalentProfile();

  const hasVerifiedCompany = user?.companies?.some((c) =>
    ([VERIFICATION_STATUS.pending, VERIFICATION_STATUS.verified] as const).includes(
      c?.company.verificationStatus as 'pending' | 'verified',
    ),
  );

  const companyHref = hasVerifiedCompany
    ? getRoutingPath(ROUTES.COMPANY_DASHBOARD)
    : getRoutingPath(ROUTES.COMPANY_CREATE);

  return (
    <Box
      sx={{
        alignItems: 'center',
        color: theme.topNavigation.main,
        display: { md: 'flex', xs: 'none' },
        gap: theme.spacing(4),
      }}
    >
      {isAuthenticated ? (
        <>
          {user?.profile?.id ? (
            <Link
              sx={{
                color: 'inherit',
                fontSize: '0.875rem',
                fontWeight: 500,
                textDecoration: 'none',
              }}
              href={getRoutingPath(ROUTES.TALENT_DASHBOARD)}
            >
              Talent
            </Link>
          ) : (
            <Box
              component="span"
              onClick={() => createTalentProfile()}
              sx={{ color: 'inherit', cursor: 'pointer', fontSize: '0.875rem', fontWeight: 500 }}
            >
              Create profile
            </Box>
          )}
          <Link
            href={companyHref}
            sx={{ color: 'inherit', fontSize: '0.875rem', fontWeight: 500, textDecoration: 'none' }}
          >
            {hasVerifiedCompany ? 'Company' : 'Post a job'}
          </Link>
          {(user.isAdmin || user.isImpersonate) && (
            <Link
              sx={{
                color: 'inherit',
                fontSize: '0.875rem',
                fontWeight: 500,
                textDecoration: 'none',
              }}
              href={getRoutingPath(ROUTES.ADMIN_TALENTS)}
            >
              Admin
            </Link>
          )}
          {user.isAdmin && <NotificationsMenu />}
        </>
      ) : (
        <></>
      )}
    </Box>
  );
};
